import React, { useMemo, useState } from 'react';

import { useTheme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import PersonOutline from '@material-ui/icons/PersonOutline';
import Search from '@material-ui/icons/Search';

import {
    leftCluster,
    personIcon,
    root,
    searchIcon,
    searchInput,
    searchWrap,
    titleText,
} from './MyAgentsToolbar.style';

const MyAgentsToolbar = ({ title, searchPlaceholder, onSearchChange }) => {
    const [query, setQuery] = useState('');
    const theme = useTheme();
    const isSmDown = useMediaQuery(theme.breakpoints.down('sm'));
    const isLgDown = useMediaQuery(theme.breakpoints.down('lg'));

    const rootStyle = useMemo(
        () =>
            isSmDown
                ? { ...root, flexDirection: 'column', alignItems: 'stretch', alignContent: 'stretch' }
                : root,
        [isSmDown]
    );

    const searchWrapStyle = useMemo(
        () =>
            isSmDown
                ? { ...searchWrap, flex: '1 1 100%', maxWidth: '100%', width: '100%', minWidth: 0 }
                : isLgDown
                  ? { ...searchWrap, maxWidth: 320, minWidth: 140 }
                  : searchWrap,
        [isSmDown, isLgDown]
    );

    const handleChange = (e) => {
        const v = e.target.value;
        setQuery(v);
        if (typeof onSearchChange === 'function') {
            onSearchChange(v);
        }
    };

    return (
        <div style={rootStyle}>
            <div style={leftCluster}>
                <PersonOutline style={personIcon} aria-hidden />
                <Typography component="span" style={titleText}>
                    {title}
                </Typography>
            </div>
            <div style={searchWrapStyle}>
                <input
                    type="search"
                    value={query}
                    onChange={handleChange}
                    placeholder={searchPlaceholder}
                    style={searchInput}
                    aria-label={searchPlaceholder}
                />
                <Search style={searchIcon} aria-hidden />
            </div>
        </div>
    );
};

export default MyAgentsToolbar;
